import { Typography } from "../../../components/util";
import AuthContainer from "../authContainer";
import * as Styled from "./styles.css";

const ChangePasswordSuccess = ({ email }: Record<string, string>) => {
  return (
    <AuthContainer
      headerTitle="Your password has been reset successfully"
      preventRedirect
    >
      <Typography paragraph styled={{ text: { shade: "weak" } }}>
        You can now return to the log in page to continue to log in.
      </Typography>

      <Styled.LogInButton
        router
        href="/"
        variant="contained"
        color="accent"
        fullWidth
      >
        Return to log in
      </Styled.LogInButton>
    </AuthContainer>
  );
};

export default ChangePasswordSuccess;
